import React from 'react';
import { Form, Popover } from 'antd';
import EventsSelect from '@src/emp-3.0/components/EventsSelect';
import CustomFormItem from '@src/emp-3.0/components/Metrics/IndividualMetric/MetricBuilder/CustomFormItem';
import EventItem from '@src/emp-3.0/components/Metrics/Flow/FlowForm/EventItem';
import { EEventType } from '@src/emp-3.0/types';
import { useFlowStore } from '@src/pages/workflow/store/flowBuilder';
import { InfoCircleOutlined } from '@ant-design/icons';

interface IWithoutEventProps {
  form: any;
  isView: boolean;
}

const WithoutEvent: React.FC<IWithoutEventProps> = ({ form, isView }) => {
  const { withoutEvent, setWithoutEvent } = useFlowStore();

  const withoutEventId = Form.useWatch(['definition', 'events', 'without_event'], form);

  const onEventChange = (_, type, event) => {
    const eventType = typeof event === 'string' ? 'raw' : 'mapped';
    const eventValue = eventType === 'mapped' ? event.event_id : event;

    // Clear the event from store when selecting a new event
    setWithoutEvent(null);

    form.setFieldsValue({
      definition: {
        events: {
          without_event: eventValue,
        },
      },
    });
  };

  return (
    <div style={{ marginLeft: '28px' }}>
      <div id="without_event" style={{ display: withoutEventId || !isView ? 'block' : 'none' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ width: '286px', display: 'flex', alignItems: 'center' }}>
            <span style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.85)' }}>Exclusion Event</span>
            <span style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.45)', marginLeft: '4px' }}>
              (Optional)
            </span>
            <Popover
              title={null}
              content={
                <div style={{ position: 'relative', width: 600 }}>
                  <img
                    src={
                      'https://storage.googleapis.com/app-emp-static/metric_flow/AtoBwithoutC.png'
                    }
                    alt=""
                    style={{ width: 594 }}
                  />
                </div>
              }
              placement="rightBottom"
            >
              <InfoCircleOutlined style={{ opacity: '0.4', fontSize: '18px', marginLeft: '8px' }} />
            </Popover>
          </div>

          <CustomFormItem
            name={['definition', 'events', 'without_event']}
            label=""
            dependencies={[
              ['definition', 'events', 'start_event'],
              ['definition', 'events', 'success_event'],
              ['definition', 'events', 'error_event'],
            ]}
            labelCol={{ span: 6 }}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const firstEvent = getFieldValue(['definition', 'events', 'start_event']);
                  const secondEvent = getFieldValue(['definition', 'events', 'success_event']);
                  const errorEvent = getFieldValue(['definition', 'events', 'error_event']);
                  if (
                    !value ||
                    !(firstEvent === value || secondEvent === value || errorEvent?.includes(value))
                  ) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(
                      'Without Event cannot be the same as Initial Event or Complete Event or Error Event',
                    ),
                  );
                },
              }),
            ]}
            style={{ display: isView ? 'none' : 'block', flex: 1, marginTop: '24px' }}
          >
            <EventsSelect
              eventType={EEventType.WITHOUT_EVENT}
              onChange={(value, event) => {
                onEventChange(value, 'without_event', event);
              }}
            />
          </CustomFormItem>
        </div>
        <EventItem
          type={EEventType.WITHOUT_EVENT}
          eventId={withoutEventId}
          event={withoutEvent}
          viewModeProps={{
            onEdit: (event) => {
              setWithoutEvent(event);
            },
            onDelete: () => {
              setWithoutEvent(null);
              form.setFieldValue(['definition', 'events', 'without_event'], null);
            },
            onClone: (event) => {
              setWithoutEvent(event);
            },
          }}
          editModeProps={{
            onSave: (event) => {
              form.setFieldsValue({
                definition: { events: { without_event: event.event_id } },
              });
              setTimeout(() => {
                setWithoutEvent(null);
              }, 100);
            },
            onCancel: () => {
              setWithoutEvent(null);
            },
            onChange: (event) => {
              if (Number(event)) {
                form.setFieldsValue({
                  definition: { events: { without_event: event } },
                });
                form.validateFields([
                  ['definition', 'events', 'start_event'],
                  ['definition', 'events', 'success_event'],
                  ['definition', 'events', 'error_event'],
                ]);
                setTimeout(() => {
                  setWithoutEvent(null);
                }, 100);
              } else {
                setWithoutEvent(event);
              }
            },
          }}
        />
      </div>
    </div>
  );
};

export default WithoutEvent;
